import { render, staticRenderFns } from "./FieldCardDetailItem.vue?vue&type=template&id=990c4f4c&scoped=true"
import script from "./FieldCardDetailItem.vue?vue&type=script&lang=js"
export * from "./FieldCardDetailItem.vue?vue&type=script&lang=js"
import style0 from "./FieldCardDetailItem.vue?vue&type=style&index=0&id=990c4f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990c4f4c",
  null
  
)

export default component.exports